import ProductGiftListProvider from './hooks/useProductGiftList';

import { ProductGiftListProps } from './@types/ProductGiftListProps';

const ProductGiftList = (props: ProductGiftListProps) => (
	<ProductGiftListProvider {...props}>
		<div className="vtex-product-gifts-0-x-productGiftListContainer productGiftListContainer">
			<div className="vtex-product-gifts-0-x-giftListItem giftListItem br3 ba b--muted-3 mv2 pa5">{props.children}</div>
			<div className="vtex-product-gifts-0-x-giftListItem giftListItem br3 ba b--muted-3 mv2 pa5">{props.children}</div>
		</div>
	</ProductGiftListProvider>
);

export default ProductGiftList;
